"use client";

import { motion } from "framer-motion";
import { useTranslations } from "@frontend/lib/next-intl-typed";
import {
  useInsuranceConnectorContext,
  useInsuranceConnectorSend,
} from "../insurance-connector-provider";

interface ConfirmDisconnectProps {
  isMobile?: boolean;
}

export function ConfirmDisconnect({
  isMobile = false,
}: ConfirmDisconnectProps) {
  const context = useInsuranceConnectorContext();
  const send = useInsuranceConnectorSend();
  const t = useTranslations("InsuranceConnector");

  const isSecondary = context.disconnectTarget === "secondary";
  const label = isSecondary ? t("LabelSecondary") : t("LabelPrimary");

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      className={`rounded-3xl ${isMobile ? "w-full p-4" : "w-96 p-8"}`}
    >
      <div className="flex flex-col gap-4">
        <p className="text-xl font-semibold text-gray-900">
          {t("DisconnectConfirmation", { label })}
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            onClick={() => send({ type: "CANCEL_DISCONNECT" })}
            className="flex-1 rounded-full border border-black px-2 py-2.5 text-md font-semibold text-black hover:text-white transition-colors hover:bg-black"
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            onClick={() => send({ type: "CONFIRM_DISCONNECT" })}
            className="flex-1 rounded-full bg-black px-2 py-2.5 text-md font-semibold text-white transition-all duration-300 hover:text-white hover:bg-[#00A3FF] border border-black hover:border-[#00A3FF]"
          >
            {t("Disconnect")}
          </button>
        </div>
      </div>
    </motion.div>
  );
}
